module.exports = __webpack_public_path__ + "b18ff5f0dd1aae162af28c246e4a7beb.svg";